
<div class="val-page-saisie-parametres-connexion val-flex-conteneur">
  <div class="val-flex-1"></div>
  <div class="val-flex-conteneur val-flex-colonne">
    <div class="val-flex-1"></div>
    <div class="val-page-saisie-parametres-connexion-panel val-flex-conteneur val-flex-colonne">
      <div class="val-page-saisie-parametres-connexion-panel-entete">
        <div class="val-flex-conteneur">
          <div class="val-flex-1"></div>
          <img src="assets/images/logo-ammon.svg" width="336"/>
          <div class="val-flex-1"></div>
        </div>
        <div class="val-page-saisie-parametres-connexion-panel-entete-titre">Entrez votre code client</div>
        <div class="val-page-saisie-parametres-connexion-panel-entete-sous-titre">Votre plateforme de gestion de la formation</div>
      </div>
      <div class="val-page-saisie-parametres-connexion-panel-contenu val-flex-conteneur val-flex-colonne val-flex-1">
        <div class="val-page-saisie-parametres-connexion-erreur"
             [ngClass]="{'val-invisible': !erreur}">
          Code client invalide
        </div>
        <div (keyup)="KeyUp($event)">
          <kendo-textbox class="val-page-saisie-parametres-connexion-editeur"
                         placeholder="Code client"
                         [(value)]="codeClient">
          </kendo-textbox>
        </div>
        <div class="val-flex-1"></div>
        <div class="val-page-saisie-parametres-connexion-commande val-flex-conteneur">
          <div class="val-flex-1"></div>
          <button class="val-page-saisie-parametres-connexion-bouton"
                  (click)="Connexion()">
            Suivant
          </button>
          <div class="val-flex-1"></div>
        </div>
      </div>
    </div>
    <div class="val-flex-1"></div>
  </div>
  <div class="val-flex-1"></div>
</div>
